import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import SvgIcon from '../presentation/SvgIcon';
import { getPageLoadingDom, getFromLocalStorage } from '../utils';
import Login from './Login';
import Home from './Home';
import { withRouter } from 'react-router'
import { Switch, Route } from 'react-router-dom';

class App extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let user = getFromLocalStorage('user');
        if(!user) {
            this.props.dispatch({ type: actions.INITIAL_GET_USER_DONE });
        } else {
            this.props.dispatch({ type: actions.GET_USER_REQUEST, userData: user });
        }
    }

    render() {
        return (
            <div className="page-container">
            {this.props.userAccountInitial ?
                <div>{getPageLoadingDom()}</div> :
                <Switch>
                    <Route exact path='/login' component={Login} />
                    <Route path='/' component={withRouter(Home)} />
                </Switch>
            }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userAccountInitial: state.userAccount.initial
    }
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.js